var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { filter: "url(#id-30a)" },
      React.createElement("rect", { x: "8", y: "4", width: "40", height: "40", rx: "20", fill: "url(#id-31b)", shapeRendering: "crispEdges" }),
      React.createElement("rect", { x: "9", y: "5", width: "38", height: "38", rx: "19", stroke: "#fff", strokeWidth: "2", shapeRendering: "crispEdges" }),
      React.createElement("path", { d: "M34.3333 19L25.4444 29L21 24", stroke: "#fff", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "id-30a", x: "0", y: "0", width: "56", height: "56", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
        React.createElement("feOffset", { dy: "4" }),
        React.createElement("feGaussianBlur", { stdDeviation: "4" }),
        React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0.615686 0 0 0 0 0.870588 0 0 0 0 0.890196 0 0 0 0.36 0" }),
        React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_2856_38009" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "effect1_dropShadow_2856_38009", result: "shape" })
      ),
      React.createElement(
        "linearGradient",
        { id: "id-31b", x1: "35.5", y1: "11", x2: "9.5", y2: "26.5", gradientUnits: "userSpaceOnUse" },
        React.createElement("stop", { stopColor: "#22BDCB" }),
        React.createElement("stop", { offset: "1", stopColor: "#88ECF5" })
      )
    )
  );
});